import type { Contract } from "@/generated/types";

interface ContractMemberListProps {
  users: Contract["users"];
}

export default function ContractMemberList({ users }: ContractMemberListProps) {
  if (users.length === 0) {
    return null;
  }

  return (
    <p className="mt-2 text-xs uppercase tracking-widest text-primary-600 dark:text-primary-400">
      Membros: {users.map((u) => u.fullName).join(", ")}
    </p>
  );
}
